export type PhaseFourParamaters = {
    zohoId: string;
};

export class PhaseFour {
    chECFase_c: string;
    OptyNumber: string;

    constructor({ zohoId }: PhaseFourParamaters) {
        this.chECFase_c = "preventa";
        this.OptyNumber = zohoId;
    }
}
